/** @jsx h */
import { Component, h, JSX } from 'preact';
import { sendAnalyticsTrack } from '../../../../../../common/js/TrackAnalyticsHelper';
import InformationLabel from '../../../../../../common/components/information-label';
import CustomizedControl from '../../../../../../common/components/customized-control';

interface ControlStyle {
  backgroundColor: string;
  backgroundOpacity: number;
  labelColor: string;
  labelOpacity: number;
}

interface InformationItemProps {
  isInterstitialAdUnit: boolean;
  controlStyle: ControlStyle;
  remainingTime: number;
  showRecommendation: boolean;
  canInstallIcon: boolean;
  useCrossCloseButton: boolean;
}

export class InformationItem extends Component<InformationItemProps> {
  constructor(props: InformationItemProps) {
    super(props);
  }

  render(): JSX.Element {
    const {
      isInterstitialAdUnit,
      controlStyle,
      remainingTime,
      showRecommendation,
      canInstallIcon,
      useCrossCloseButton
    } = this.props;
    return (
      <CustomizedControl
        id="recommandation"
        onTouchStart={(e: TouchEvent) => e.stopPropagation()}
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          sendAnalyticsTrack(e);
        }}
        style={{
          padding: '6px 6px',
          margin: !useCrossCloseButton && !isInterstitialAdUnit ? '0 6px' : ''
        }}
        fontSize={13}
        controlStyle={controlStyle}
      >
        <InformationLabel
          remainingTime={remainingTime}
          showRecommendation={showRecommendation}
          canInstallIcon={canInstallIcon}
        />
      </CustomizedControl>
    );
  }
}
